import { Editor } from "@tinymce/tinymce-react";
import React, { useCallback, useState } from "react";
import { useController } from "react-hook-form";
import "tinymce/icons/default";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/themes/silver";
import 'tinymce/models/dom/model';

function MCSControlEditor(props) {
  const [state, setState] = useState({
    invalid: false,
    value: "",
  });

  const { field, fieldState } = useController(props);
  const handleChange = (newValue, editor) => {
    field.onChange(newValue.trim());
    props.handleChange();
  };

  const handleBlur = useCallback(
    (e) =>
      setState({
        invalid: e.target.value === "",
        value: e.target.value,
      }),
    []
  );
  return (
    <>
      <Editor
        scriptLoading={{ async: true }}
        value={field.value}
        name={props.name}
        onEditorBlur={handleBlur}
        onEditorChange={handleChange}
        init={{
          license_key: 'gpl',
          height: 300,
          branding: false,
          force_br_newlines: false,
          indent: false,
          plugins: "code autolink",
          toolbar: "bold italic code",
          menubar: false,
          forced_root_block: false,
          paste_as_text: true,
          body_class: "mcsControlEditor",
        }}
      />
    </>
  );
}

export default MCSControlEditor;
